import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import useFormatter from "@coworker/app/src/hooks/useFormatter";
import { useTranslation } from "@coworker/locales";
import styles from "../item-delivery.module.css";

interface ItemDeliveryQuantityProps {
  quantity: number | undefined;
}

export const ItemDeliveryQuantity = ({
  quantity,
}: ItemDeliveryQuantityProps) => {
  const { formatNumber } = useFormatter();
  const { t } = useTranslation();

  function returnFormattedStockData(quantity: number | undefined) {
    if (!quantity && quantity !== 0) return "";
    return `${formatNumber(quantity)}`;
  }

  return (
    <FixaText
      textStyle={"Body.S"}
      className={styles["item-delivery-quantity"] || ""}
    >
      {quantity
        ? `- ${returnFormattedStockData(quantity)}${t("pcsString")}`
        : ``}
    </FixaText>
  );
};
